require('./filter-preview.component.scss');

class FilterPreviewController {
  constructor(
    $scope,
    $element,
    $q,
    $timeout,
    CurrentFilterService,
    PermissionService,
    RouterService,
    FilterDataFactory,
    CurrentModelService,
    FilterEditorService,
    FiltersService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$q = $q;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.CurrentModelService = CurrentModelService;
    this.FilterEditorService = FilterEditorService;
    this.FiltersService = FiltersService;
    this.filterData = FilterDataFactory(true);
    $timeout(() => this.setHeight());
  }

  setHeight() {
    const stat = this.$element[0].querySelector('sc-stat-menu');
    const facts = this.$element[0].querySelector('sc-facts-menu');
    const dragable = this.$element[0].querySelector('sc-filter-drill-down-draggable');
    const menuHeight = (this.$element[0].querySelector('sc-view-tabs').offsetHeight +
      (dragable ? (dragable.offsetHeight ? dragable.offsetHeight : 79) : 0) +
      (stat ? (stat.offsetHeight ? stat.offsetHeight : 31) : 0) +
      (facts ? (facts.offsetHeight ? facts.offsetHeight : 31) : 0));
    // this.$element[0].querySelector('sc-filter-view').style.height = `calc(100% - ${menuHeight})`;
    this.$element[0].querySelector('.sc-view-container').style.height = `calc(100% - ${menuHeight}px)`;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filter() {
    return this._filter;
  }

  set filter(filter) {
    // filter.__proto__ = this.CurrentFilterService.filter;
    this._filter = filter.filter;
    this.filterData.update(this._filter);
  }

  get filterBar() {
    return this.CurrentFilterService.filterBar;
  }
}

export const FilterPreviewComponent = {
  template: require('./filter-preview.component.html'),
  // require: {dashboard: '^scDashboard'},
  bindings: {
    filter: '<',
  },
  controller: FilterPreviewController,
};



// WEBPACK FOOTER //
// ./src/filter/editor/filter-preview/filter-preview.component.js